import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { media } from "../../data/media";
import { container } from "../../utils/styles";
const banners = [{
  title: "Gepersonaliseerde cadeaus",
  text: "Met naam, tekst of eigen foto — speciaal voor de ontvanger gemaakt.",
  cta: "Shop cadeaus",
  to: "/shop?categorie=Gepersonaliseerd",
  image: media.gifts,
  alt: "Cadeau inpakken met een houten naambord",
  span: "lg:col-span-7"
}, {
  title: "Woondecoratie",
  text: "Vazen en objecten met een zachte, gelaagde textuur.",
  cta: "Shop decoratie",
  to: "/shop?categorie=Woondecoratie",
  image: media.dining,
  alt: "Eettafel met een 3D-geprinte vaas met tulpen",
  span: "lg:col-span-5"
}];
export function PromoBanners() {
  return <section aria-label="Uitgelichte collecties" className="bg-paper pb-16 lg:pb-24" data-id="element-184" data-mp="35vv9t03ak0x7">
      <div className={`${container} grid gap-4 sm:gap-6 lg:grid-cols-12`} data-id="element-185" data-mp="30x1ynebh8m07">
        {banners.map(b => <Link key={b.title} to={b.to} className={`group relative block h-[420px] overflow-hidden rounded-xl bg-sand lg:h-[560px] ${b.span}`} data-id="element-186" data-mp="3twk5e9tvewq5">
            <img src={b.image} alt={b.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-187" data-mp="7hqyahsguwaa" />
            <div className="absolute bottom-4 left-4 right-4 max-w-sm rounded-xl bg-paper p-6 sm:bottom-6 sm:left-6 sm:right-auto" data-id="element-188" data-mp="blgikv23yrpi">
              <h3 className="text-2xl font-medium tracking-[-0.02em] text-ink" data-id="element-189" data-mp="3fxar5fp86cot">{b.title}</h3>
              <p className="mt-2 text-sm text-muted" data-id="element-190" data-mp="3jzffbywwmh42">{b.text}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-ink" data-id="element-191" data-mp="3jxumqeu5h88u">
                <span className="underline-offset-4 group-hover:underline" data-id="element-192" data-mp="3ow5tggp5f2mu">{b.cta}</span>
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" data-id="element-193" data-mp="z8op1gb9w6t4" />
              </span>
            </div>
          </Link>)}
      </div>
    </section>;
}